import DOMPurify from 'dompurify';

DOMPurify.removeHook('afterSanitizeAttributes');
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export default {
    mounted(el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value, { ADD_ATTR: ['target'] });
    },
    updated(el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value, { ADD_ATTR: ['target'] });
    }
};
